import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFilter from "react-select";
import DateTimePicker from 'react-datetime';
import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");

function MyMaskMonthEditor(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-1]/, /[0-9]/, "/", /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/]}
      placeholderChar={"_"}
      showMask
      keepCharPositions={true}
      guide={true}
    />
  );
}
class ChatTimKiemControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_coquan: true, // co dang load ding danh muc nguon tin ko
      source_coquan: [], //danh muc options cho nguon tin
      //searching
      search_loading: false,
      search_result: { danhsach: [], total: 0 }, //ket qua tim kiem
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : props.value, //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              Page: 1,
              PageSize: 10,
              MaCQ: "0", //trung tam xu ly gui thong tin
              Thang: "",
              TenSK: "", //tim kiem theo ten tau
            }
          : props.value, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }
  componentDidMount() {
    if (this.props.callback) {
      this.props.callback(this.handleSearch);
    }
    this.loadDanhMuc();
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    this.setState(s);
    console.log(s);
  };
  //submit thong tin ve DB
  handleSearch = (pageIndex) => {
    var search = {};
    Object.assign(search, this.state.after);
    search.Page = pageIndex === undefined ? search.Page : pageIndex;
    this.setState({ saving: true, errorLog: "" });
    console.log(search);
    server
      .post("chat/search", search)
      .then((response) => {
        var before = {};
        var after = search;
        Object.assign(before, after);
        this.setState({
          dataChanged: false,
          canSaved: false,
          saving: false,
          errorLog: "",
          search_loading: false,
          search_result: response,
        });
        //thong bao cho parent biet co data duoc saved
        if (this.props.onSearched) {
          this.props.onSearched(after, response);
        }
      })
      .catch((error) =>
        this.setState({
          saving: false,
          search_loading: false,
          errorLog: error + "",
        })
      );
  };
  loadDanhMuc() {
    //load danh muc doi tac
    server
      .query("coquan/getall")
      .then((response) => {
        var list = [];
        var find = undefined;
        response.map((item, index) => {
          var option = { value: item.MaCQ, label: item.TenCoQuan };
          list.push(option);
          if (item.MaCQ === global.User.MaCQ && find === undefined) {
            find = option;
          }
        });
        list.push({ value: "0", label: "---Tất cả---" });
        this.setState({ canSaved: true, source_coquan: list, loading_coquan: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_coquan: false });
      });
  }
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <InputLabel id="labelCoquan">Nơi gửi:</InputLabel>
          {this.state.loading_coquan ? (
            <CircularProgress />
          ) : (
            <div style={{ zIndex: 99999 }}>
              <SelectFilter
                id="cboMacq"
                options={this.state.source_coquan}
                placeholder=""
                labelId="labelCoquan"
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                menuPosition={"fixed"}
                value={this.state.after.MaCQ}
                onChange={(item) => this.saveField("MaCQ", item)}
              ></SelectFilter>
            </div>
          )}
        </Grid>
        <Grid item xs={4}>
          <FormControl>
            <InputLabel htmlFor="maskInput">
              Tháng:
            </InputLabel>
            <Input
              name="textmask"
              id="maskInput"
              autoComplete="none"
              inputComponent={MyMaskMonthEditor}
              value={this.state.after.Thang}
              onChange={(event) => {
                this.saveField("Thang", event.target.value);
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <TextField
            id="txtTenSK"
            className={classes.textbox}
            label="Tên sự kiện:"
            value={this.state.after.TenSK}
            inputProps={{
              className: classes.uppercaseText,
              maxLength: 100,
            }}
            onChange={(event) => this.saveField("TenSK", event.target.value)}
          />
        </Grid>
        <Grid item xs={2}>
          <MyButton
            onClick={() => this.handleSearch()}
            color="primary"
            text="Tìm kiếm"
          />
        </Grid>
        <Grid item xs={10}>
          {this.state.saving ? (
            <CircularProgress />
          ) : this.state.errorLog === "" ? null : (
            this.state.errorLog
          )}
        </Grid>
      </Grid>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
  cboMacq: {
    backgroundColor: "gray",
  },
});
export default withStyles(styles, { withTheme: true })(ChatTimKiemControl);
